module.exports = __webpack_public_path__ + "img/accessory_shirt_04.33391966.svg";